import { render, staticRenderFns } from "./ProductTemplateForm.vue?vue&type=template&id=27655cd4"
import script from "./ProductTemplateForm.vue?vue&type=script&lang=js"
export * from "./ProductTemplateForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports